import { create } from 'zustand';

interface AppReleaseState {
  needsRefresh: boolean;
  markStale: () => void;
  refreshNow: () => void;
}

export const useAppReleaseStore = create<AppReleaseState>((set) => ({
  needsRefresh: false,
  markStale: () => set({ needsRefresh: true }),
  refreshNow: () => {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  },
}));
